import {
	Chip,
	FormControl,
	Input,
	InputLabel,
	MenuItem,
	Select,
	type Theme,
	makeStyles,
	useTheme,
} from "@material-ui/core";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { Profile } from "../../models/Profile";
import { getProfiles } from "../../repositories/UsersRepository";

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		"& .MuiSelect-select": {
			height: "auto",
			minHeight: "40px",
		},
	},
	formControl: {
		margin: theme.spacing(1),
		width: "100%",
	},
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
	noLabel: {
		marginTop: theme.spacing(3),
	},
}));

const getStyles = (profileId: number, profiles: Profile[], theme: Theme) => {
	return {
		fontWeight: !!profiles.find((p) => p.ProfileId === profileId)
			? theme.typography.fontWeightRegular
			: theme.typography.fontWeightMedium,
	};
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

type Props = {
	value: number[];
	onChange: Function;
	userIdForDelete: number | null;
	setprofileError: (err: string) => void;
	disabled?: boolean;
};

export const ProfilesPicker = ({
	value,
	onChange,
	userIdForDelete,
	setprofileError,
	disabled,
}: Props) => {
	const classes = useStyles();
	const theme = useTheme();
	const [isLoading, setIsLoading] = useState(true);
	const [profiles, setProfiles] = useState<Profile[]>([]);

	useEffect(() => {
		let canceled = false;
		setIsLoading(true);
		getProfiles()
			.then((res) => {
				if (res.ok) {
					const profilesData = get(res, "data.tables[0].rows", null);
					if (profilesData) {
						if (canceled) return;
						setProfiles(profilesData);
					}
				} else setprofileError(res.message);
			})
			.finally(() => {
				if (canceled) return;
				setIsLoading(false);
			});
		return () => {
			canceled = true;
		};
	}, []);

	function getProfileNameById(profileId: number) {
		return (
			profiles
				.find((p) => p.ProfileId === profileId)
				?.ProfileName.replaceAll("Profile", "") || ""
		);
	}

	return (
		<div className={classes.root}>
			{!isLoading && profiles.length ? (
				<FormControl className={classes.formControl} disabled={disabled}>
					<InputLabel
						id="demo-mutiple-chip-label"
						style={
							value.length
								? { display: "flex", alignItems: "center" }
								: { display: "flex", alignItems: "center", marginTop: 10 }
						}
					>
						Profiles
					</InputLabel>
					<Select
						autoWidth={true}
						labelId="demo-mutiple-chip-label"
						id="demo-mutiple-chip"
						multiple
						value={value}
						onChange={onChange as any}
						input={<Input id="select-multiple-chip" />}
						renderValue={(selected) => (
							<div className={classes.chips}>
								{(selected as number[]).map((profileId) => (
									<Chip
										key={`selected-profile-${profileId}`}
										label={getProfileNameById(profileId)}
										className={classes.chip}
									/>
								))}
							</div>
						)}
						MenuProps={MenuProps}
					>
						{profiles.map((profile) => (
							<MenuItem
								key={`profile-${profile.ProfileId}`}
								value={profile.ProfileId}
								style={getStyles(profile.ProfileId, profiles, theme)}
							>
								{profile.ProfileName.replaceAll("Profile", "")}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			) : (
				<></>
			)}
		</div>
	);
};
